<!--
     <FieldCentro>
-->

<template>
  <div class="fc-centro-field" v-if="short && showIcon">
    <div class="fc-centro-img-cont-field">
      <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <img v-bind="attrs" v-on="on" class="fc-centro-img-field" :src="centro_logo" @error="failed_logo()" />
          </template>
          <span>{{ field.text }}</span>
        </v-tooltip>
    </div>

  </div>
  <div class="fc-centro-field" v-else>
    <div class="fc-centro-img-cont-field">
      <img class="fc-centro-img-field" :src="centro_logo" @error="failed_logo()" />
    </div>
    <!-- <div class="fc-centro-indent" :style="indent_style(centro)"></div> -->
    <div class="fc-centro-name-field">{{ field.text }}</div>
  </div>

</template>

<style>
.fc-centro-img-cont-field {
   height: 100%;
   width: 64px;
   display: flex;
   align-items: center;
   justify-content: center;
 }

.fc-centro-img-field {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.fc-centro-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 24px;
  padding: 4px 0px 4px 8px;
  position: relative;

}

.fc-centro-name-field {
  padding-left: 8px;
  width: 95%;
}
</style>

<script>
import FieldString from './FieldString.vue';
import { resolve_logo } from '@/utils/logos';

export default {
  name: 'FieldCentro',

  props: {
    field: { required: true },
    short: { type: Boolean, default: false },
    is_mobile: { type: Boolean, default: false },
    css_class: { type: String, default: "string-field-content" }
  },
  components: {
    FieldString
  },

  data() {
    return {
      faillogo: false,
    }
  },

  computed: {
    representation() {
      return '' + this.field;
    },
    showIcon() {
      return !!this.field.props
    },
    centro_logo() {
      return resolve_logo(this.field.logo, false);
    }

  },
  methods: {
    failed_logo() {
      this.faillogo = true;
     },
  },
};
</script>